import { render, staticRenderFns } from "./PaginaNaoEncontrada.vue?vue&type=template&id=e9bb2d44&scoped=true"
import script from "./PaginaNaoEncontrada.vue?vue&type=script&lang=js"
export * from "./PaginaNaoEncontrada.vue?vue&type=script&lang=js"
import style0 from "./PaginaNaoEncontrada.vue?vue&type=style&index=0&id=e9bb2d44&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9bb2d44",
  null
  
)

export default component.exports